import { useLocation, useNavigate } from 'react-router-dom';
import { useActivateMutation } from '@src/features/auth/redux';
import { routesConfig } from '@src/core/routes';
import { toast } from 'react-toastify';
import { trackError, toTrackedError } from '@src/core/sentry';

export const useActivateUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activate, { isLoading }] = useActivateMutation();

  const onActivate = () => {
    const params = new URLSearchParams(location.search);
    const key = params.get('key');

    if (!key) return;

    activate({ key }).unwrap()
      .then(() => {
        navigate(routesConfig.signIn, { replace: true });
        toast.success('success');
      })
      .catch((err: unknown) => {
        trackError(toTrackedError(err), { code: 'FE_0022', extra: { flow: 'activateUser' } });
      });
  };

  return {
    onActivate,
    isLoading,
  };
};

